import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const DashboardItem = ({
  IconComponent,
  pathToNavigate,
  title,
  description,
  customIcon,
  customIconSrc,
}) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        border: '1px solid #231F20',
        borderRadius: '12px',
        padding: { xs: '2rem', xl: '2.5rem 2rem' },
        display: 'flex',
        gap: '2rem',
        alignItems: 'center',
        cursor: 'pointer',
        width: { xs: '100%', sm: '280px', lg: '320px', xl: '350px' },
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: 'rgba(20, 44, 92, 0.05)',
          borderColor: '#142C5C',
        },
      }}
      onClick={() => navigate(pathToNavigate)}
    >
      {customIcon ? (
        <img src={customIconSrc} alt={title} style={{ width: 35, height: 35 }} />
      ) : (
        <IconComponent fontSize="large" sx={{ color: '#142C5C' }} />
      )}
      <Box>
        <Typography variant="h6" fontWeight={600} sx={{ color: '#142C5C' }}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="#666">
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default DashboardItem;
